module.exports = __webpack_public_path__ + "static/media/empresa-banner.088cbcd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/empresa-banner.png
// module id = 145
// module chunks = 0